import React, { useState, useContext } from "react";
import "../tourpopup.css";
import { AuthContext } from "../Hook/AuthProvider";
import {
  updateTourStatus
} from "../services/tourService";

export default function Tourpoup({ setTour }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { fetchProfile } = useContext(AuthContext);

  const content = [
    {
      title: "Getting started on Mntor",
      img: "/assets/images/tour1.png",
      body: "📌 Ask, and AI Answers!",
      content:
        "Get the latest current affairs, key arguments, and case studies linked to your queries instantly.",
      progbar: "/assets/images/progressbar1.png",
      button: "Next",
    },
    {
      title: "Getting started on Mntor",
      img: "/assets/images/tour1.png",
      body: "📚 Stay Exam-Ready with Insights!",
      content:
        "Get the latest current affairs, key arguments, and case studies linked to your queries instantly.",
      progbar: "/assets/images/progressbar2.svg",
      button: "Next",
    },
    {
      title: "⚠️Limitations",
      img: "/assets/images/tour2.svg",
      body: "AI isn't perfect—just like humans! Mntor AI is designed specifically for UPSC preparation",
      content:
        "Cross-check important details from official sources to ensure accuracy.",
      progbar: "",
      button: "Got It",
    },
  ];

  const handleNext = async () => {
    if (currentIndex < content.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      try {
        await updateTourStatus();
        await fetchProfile();
        setTour(true);
      } catch (error) {
        console.error("Failed to update tour status:", error);
      }
    }
  };

  return (
    <div className="termsandcondition">
      <div className="loader-container">
        <div className="data-container-tour">
          <div
            className="tour-content "
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "10px",
            }}
          >
            <div className="title-pop">{content[currentIndex].title}</div>
            <div>
              <img
                src="/assets/images/close.svg"
                alt="close"
                onClick={() => setTour(true)}
              />
            </div>
          </div>

          <div>
            <img
              src={content[currentIndex].img}
              alt="incorrect"
              style={{ width: "100%" }}
            />
          </div>

          <div style={{ marginTop: "10px" }}>
            <div className="tout-body">{content[currentIndex].body}</div>
            <div>{content[currentIndex].content}</div>
          </div>

          <div
            style={{
              display: content[currentIndex].progbar ? "flex" : "",
              justifyContent: content[currentIndex].progbar ? "space-between" : "",
              justifyItems: content[currentIndex].progbar ? "" : "center",
              marginTop: "10px",
            }}
          >
            <div>
              {content[currentIndex].progbar && (
                <img src={content[currentIndex].progbar} alt="progress bar" style={{width:"40px"}} />
              )}
            </div>
            <div>
              <button
                className="feed-sub"
                type="button"
                style={{ background: "#5ab4de", width: "80px" }}
                onClick={handleNext}
              >
                {content[currentIndex].button}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
